import clsx from "clsx";
import React from "react";
import { sanitizeHTML } from "../../../search/utils";
import { RestrictedText } from "./restricted/RestrictedText";
import { newsDisplayIsSummaryType, newsItemType } from "../../../common/types/search/news";

interface ContentProps {
	item: newsItemType;
	summary: newsDisplayIsSummaryType;
}

export function Content({ item, summary }: ContentProps) {
	const restrictionCode = item.get("restriction_code");
	const missingRoles = item.get("user_missing_roles")?.toJS();

	if (restrictionCode) {
		return (
			<RestrictedText
				restrictionCode={restrictionCode}
				missingRoles={missingRoles}
			/>
		);
	}

	return (
		<div
			className={clsx("post__text", { typography: !summary })}
			dangerouslySetInnerHTML={{
				__html: sanitizeHTML(item.get("renderResult")),
			}}
		/>
	);
}
